import React, { useEffect } from 'react';
import StructureOption from '@Pages/RetroSynthesis/StructureOption/StructureOption';

export default function StructureOptionContainer({
  targetRect,
  data,
  optionType,
  synthesisMenuOptions,
  trackingContext,
  routeType,
  clearStateAction: onClearState,
  structureOptionClearAction: onStructureOptionClear,
  fetchSynthesisPlannerMenuOptionsAction: onFetchSynthesisPlannerMenuOptions,
  openStructureIn3dAction,
}) {
  useEffect(() => {
    onFetchSynthesisPlannerMenuOptions();
    return onClearState;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <StructureOption
      targetRect={targetRect}
      data={data}
      optionType={optionType}
      onClosed={onStructureOptionClear}
      synthesisMenuOptions={synthesisMenuOptions}
      openStructureIn3d={openStructureIn3dAction}
      trackingContext={trackingContext}
      routeType={routeType}
    />
  );
}
